import React, { useState, useEffect } from 'react';
// Adjust this path to point exactly to where your Form.jsx file sits
import Form from '../components/form/OtpForm'; 
import court from '../assets/tennis-court.jpg';

const useCountUp = (endTarget, duration = 2000) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const currentCount = Math.min(
        Math.floor((progress / duration) * endTarget),
        endTarget
      );
      setCount(currentCount);

      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [endTarget, duration]);

  return count;
};

export default function OtpVerifyPage() {
  const athleteCount = useCountUp(6000, 2000);
  const instituteCount = useCountUp(100, 2000);

  return (
    <div className="h-screen w-full bg-transparent flex flex-col lg:flex-row font-sans selection:bg-black selection:text-white overflow-x-hidden overflow-y-auto lg:overflow-y-hidden">
      
      {/* LEFT COLUMN: Image & Statistics Card wrapper */}
      <div className="w-full lg:w-[52%] relative h-[45vh] lg:h-full p-4 lg:p-6 flex flex-col shrink-0">
        <div 
          className="absolute inset-4 lg:inset-6 rounded-sm bg-cover bg-center z-0"
          style={{ 
            backgroundImage: `url(${court})`
          }}
        >
          <div className="absolute inset-0 bg-black/5 rounded-sm"></div>

          {/* Statistics Card nested inside the image boundaries */}
          <div className="hidden lg:block absolute bottom-6 left-6 right-6 z-10 bg-[#F4EFE6] p-6 rounded-sm shadow-sm border border-[#EBE3D5]">
            <div className="grid grid-cols-2 gap-6 mb-4">
              
              {/* Athletes Stat - Aligned systematically */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#CC5E15]/30 flex items-center justify-center text-gray-700 shrink-0 mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                  </svg>
                </div>
                <div className="flex flex-col justify-center min-w-0">
                  <h3 className="text-2xl font-black text-black tracking-tight leading-none mb-1">
                    {athleteCount}+
                  </h3>
                  <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider leading-none">
                    Athletes
                  </p>
                </div>
              </div>

              {/* Institutes Stat - Aligned systematically */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#CC5E15]/30 flex items-center justify-center text-gray-700 shrink-0 mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
                  </svg>
                </div>
                <div className="flex flex-col justify-center min-w-0">
                  <h3 className="text-2xl font-black text-black tracking-tight leading-none mb-1">
                    {instituteCount}+
                  </h3>
                  <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider leading-none">
                    Institutes
                  </p>
                </div>
              </div>

            </div>

            <hr className="border-[#E5DAC9] mb-3" />

            <p className="text-xs text-gray-600 leading-relaxed font-normal">
              Welcome to Spirit, where athletes compete, teams unite, and memories are made. 
              More than a sports festival, Spirit is a platform for ambition, teamwork, and the pursuit of excellence.
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT COLUMN: Renders the nested form content */}
      <div className="w-full lg:w-[48%] h-full flex flex-col justify-center px-6 py-8 sm:px-12 md:px-20 lg:px-12 xl:px-20 max-w-xl mx-auto overflow-y-auto bg-transparent shrink-0">
        <div className="w-full my-auto">
          <Form />
        </div>
      </div>

    </div>
  );
}